// extracted by mini-css-extract-plugin
module.exports = {"savingsChartWrap":"TeamReportPieChart_savingsChartWrap__3vIcU","years":"TeamReportPieChart_years__1m_Sa","pieChartLoader":"TeamReportPieChart_pieChartLoader__1oCR2"};